import i18n from "i18next";

export const setDefaultLanguage = locale => {
  i18n.changeLanguage(locale);
};
